// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as SelectRegionCmp from "../../../../../../library/components/generic-components/components/SelectRegionCmp.bs.js";
import * as LocationBoundsSM from "../../../app/state-machine/LocationBoundsSM.bs.js";
import * as PlaceOrderContext from "../../context/PlaceOrderContext.bs.js";
import * as PlaceOrderFormCmp from "./PlaceOrderFormCmp.bs.js";
import * as PickUpDropFallBackCmp from "../shared/PickUpDropFallBackCmp.bs.js";
import * as PlaceOrderDataMachine from "../../../app/data-machine/PlaceOrderDataMachine.bs.js";

function PickupDropCmp(Props) {
  var getRestrictionBounds = Props.getRestrictionBounds;
  var restrictionBoundState = Props.restrictionBoundState;
  var handleRestrictedVehicles = Props.handleRestrictedVehicles;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = PlaceOrderContext.useContext(undefined);
  var dispatch = match$1.dispatch;
  var state = match$1.state;
  var match$2 = React.useState(function () {
        return state.geo_region;
      });
  var setRegion = match$2[1];
  var region = match$2[0];
  var match$3 = React.useReducer(LocationBoundsSM.machine, /* Init */0);
  var locationBoundDispatch = match$3[1];
  var locationBoundState = match$3[0];
  React.useEffect((function () {
          Curry._1(dispatch, /* ClearRestrictedVehicleIds */1);
          
        }), []);
  React.useEffect((function () {
          if (region !== undefined) {
            Curry._1(getRestrictionBounds, region.id);
            Curry._1(locationBoundDispatch, /* SetToLodingState */0);
            PlaceOrderDataMachine.fetchLocationBounds(String(region.id), country, (function (data) {
                    return Curry._1(locationBoundDispatch, {
                                TAG: /* FetchLocationBoundsSuccess */0,
                                _0: data
                              });
                  }), (function (error) {
                    return Curry._1(locationBoundDispatch, {
                                TAG: /* FetchLocationBoundsFailed */1,
                                _0: error
                              });
                  }));
          }
          
        }), [region]);
  var tmp;
  var exit = 0;
  if (typeof locationBoundState === "number") {
    exit = 2;
  } else if (locationBoundState.TAG === /* Data */0) {
    if (typeof restrictionBoundState === "number") {
      exit = typeof restrictionBoundState === "number" ? 2 : 1;
    } else if (restrictionBoundState.TAG === /* Data */0) {
      var restrictionBounds = restrictionBoundState._0;
      tmp = React.createElement(PlaceOrderFormCmp.make, {
            locationBounds: locationBoundState._0,
            handleRestrictedVehicles: (function (location_type, latLng) {
                return Curry._3(handleRestrictedVehicles, location_type, latLng, restrictionBounds);
              })
          });
    } else {
      exit = 1;
    }
  } else {
    exit = typeof restrictionBoundState === "number" ? 2 : 1;
  }
  switch (exit) {
    case 1 :
        tmp = React.createElement("p", {
              className: "error_section"
            }, "Something Went Wrong");
        break;
    case 2 :
        tmp = region !== undefined ? React.createElement(PickUpDropFallBackCmp.make, {}) : React.createElement("p", {
                className: "no_selection"
              }, "Select Geo Region First!");
        break;
    
  }
  return React.createElement("div", {
              className: "place_order_step__1"
            }, React.createElement(SelectRegionCmp.make, {
                  setRegion: (function (value) {
                      Curry._1(dispatch, {
                            TAG: /* SetGeoRegion */3,
                            _0: value
                          });
                      return Curry._1(setRegion, (function (param) {
                                    return value;
                                  }));
                    }),
                  className: "select_region_filed"
                }), tmp);
}

var make = PickupDropCmp;

export {
  make ,
  
}
/* react Not a pure module */
